import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { IOrder, IState, IParkerProfileData, IAdditionalVehicles, IAdditionalEmails, IContactShort, ILotList, IParkerProfileQuery, IParkerProfileDetail, ICompaniesShortList, ISpaceEmailUsers, ILotRateList, IStallTypes, IApnSpaceEmailLink, ISpaceEmailByEntityId, IParkersReadyForactivation, IParkerActivationReturnData, IParkerMassUpdateCompany, IParkerMassUpdateRate, IParkerMassUpdateParkerPayType, IParkerMassUpdateInvoiceDeliveryMethod, IParkerMassUpdate, ISettingsState, IParkerProfileForParkerTable, IParkerProfileImportResult, IMarketCompanyRatesByLotNumberWithCompanyId, IUniqueMarketRatesForLotNumber, IParkerSpaceUpdateCriteria, IParkerDeleteSpaceEmailAccount, ISpaceDeleteSpaceEmailLink, ICompanyDetail, ISpaceEmailUsersQueryResult, ISpaceEmailQueryForEmailUpdate, ILotDisableSpace, IInvoiceListWithBalance, IInvoiceAdminQueryResults, ILotUsageMetrics, IApnSpaceRefund, IPaymentDeclineTransaction, ICompanySearchCriteria, ICompanyQueryCriteria, ICompanyNew, ICompanyUpdate, ICompanySpaceEmailLink, IParkerCompanyList, IAdditionalContact, INewAdditionalContact, IUpdatedditionalContact, IParkersFourUp} from '../../../shared/interfaces';
import { UtilitiesService } from '../helper/utilities.service';
import { environment } from 'src/environments/environment';
import { Contacts } from 'src/app/shared/data/contact';


const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
     
    })
  };

  const httpSpaceOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    })
  };

@Injectable()
export class DataDomainListService {
    baseUrl: string = '';
    domainListUrl = 'DomainList';
   
    constructor(private http: HttpClient) {
        this.baseUrl = environment.RestServer;  

       
         
    }


    GetPaymentNegativePaymentExceptionList(): Observable<string[]> {

        return this.http.get<string[]>(`${this.baseUrl}${this.domainListUrl}/getadminpaymentreversalexceptionlist`,httpOptions)
            .pipe(catchError(this.handleError));
      
    }


    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof Error) {
            console.error('Error thrown: ' + JSON.stringify(error));
            const errMessage = error.error.message;
            return throwError(() => errMessage);
            // Use the following instead if using lite-server
            // return Observable.throw(err.text() || 'backend server error');
        }
        return throwError(() => error || 'server error');
    }


}